import { ReactElement } from 'react';
import { colors } from '@monofront/theme';
import {
  Carousel,
  CarouselSlide,
} from '@monofront/design-system/components/Carousel';
import Card from './Card';
import { IEditorialCard } from './types';

interface ICardsListProps {
  title?: string;
  richTitle?: ReactElement<any>;
  grid?: boolean;
  cardList: IEditorialCard[];
}

const defaultColors = [colors.primary3, colors.tertiary2, colors.secondary3];

const CardsList: React.FC<ICardsListProps> = ({
  cardList,
  title,
  richTitle,
  grid,
}) => {
  const CardsWrapper = grid ? 'li' : CarouselSlide;
  const Cards = cardList.map((card, index) => {
    return (
      <CardsWrapper key={index}>
        <Card
          title={card.title}
          image={card.image}
          url={card.url}
          bgColor={card.bgColor || defaultColors[index % defaultColors.length]}
        />
      </CardsWrapper>
    );
  });

  return (
    <>
      <section className="container-cards">
        {grid ? (
          <ul className="grid-cards">{Cards}</ul>
        ) : (
          <Carousel
            hasGradient
            headerTitle={
              <>
                {title && <h2 className="title">{title}</h2>}
                {richTitle && <div className="title">{richTitle}</div>}
              </>
            }
            spaceBetween={14}
            slidesPerView={1.3}
            navigation={true}
            freeMode={true}
            breakpoints={{
              500: {
                slidesPerView: 2.3,
              },
              800: {
                slidesPerView: 3,
                freeMode: false,
              },
              1180: {
                slidesPerView: 5,
                freeMode: false,
              },
            }}
          >
            {Cards}
          </Carousel>
        )}
      </section>
      <style jsx>{`
        .container-cards .title {
          margin-bottom: var(--space-4);
          font-size: var(--font-size-3);
        }
        .container-cards .grid-cards {
          display: flex;
          flex-wrap: wrap;
          margin: var(--negative-space-2);
        }
        .container-cards .grid-cards > :global(li) {
          flex: 1;
          padding: var(--space-2);
        }
        .container-cards :global(.swiper) {
          margin: var(--negative-padding-layout-base);
          padding: var(--padding-layout-base);
          width: 100vw;
        }

        @media (min-width: 801px) {
          .container-cards .grid-cards {
            margin: var(--negative-space-3);
          }
          .container-cards .grid-cards > :global(li) {
            padding: var(--space-3);
          }
          .container-cards :global(.swiper) {
            margin: auto;
            padding: 0;
          }
        }
      `}</style>
    </>
  );
};

export default CardsList;
